import { render, staticRenderFns } from "./MapLegend.vue?vue&type=template&id=1d1c33ba&scoped=true&"
import script from "./MapLegend.vue?vue&type=script&lang=js&"
export * from "./MapLegend.vue?vue&type=script&lang=js&"
import style0 from "./MapLegend.vue?vue&type=style&index=0&id=1d1c33ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1c33ba",
  null
  
)

export default component.exports